<template>
  <div class="border-1 border-top advanceOpt">
            <div class="row justify-content-between align-center py-2">
              <!-- <div class="col-md-8 d-flex align-center" v-if="clearallFilter"> -->
              <div class="col-md-8 d-flex align-center" style="font-size:14px;" v-if="clearallFilter">
                <div class="border-1 border-end pe-1" v-if="filterIcon()">
                  <v-icon size="17px"> mdi-filter </v-icon>
                </div>

                <div class="d-flex flex-wrap ms-2" style="font-size:14px;">
                  <span
                    v-if="includedAirlines.length > 0"
                    class="d-flex op-font"
                  >
                    <span class="fw-500">INCL:</span>
                    <div
                      v-for="(data, index) of includedAirlines"
                      :key="index"
                      class="ms-1"
                    >
                      <span>{{ data }}</span>
                      <span v-if="index !== includedAirlines.length - 1"
                        >,</span
                      >
                    </div>
                    <span class="ms-1 fw-500">|</span>
                  </span>

                  <span
                    v-if="excludedAirlines.length > 0"
                    class="d-flex op-font"
                  >
                    <span class="fw-500">EXCL:</span>
                    <div
                      v-for="(data, index) of excludedAirlines"
                      :key="index"
                      class="ms-1"
                    >
                      <span>{{ data }}</span>
                      <span v-if="index !== excludedAirlines.length - 1"
                        >,</span
                      >
                    </div>
                    <span class="ms-1 fw-500">|</span>
                  </span>

                  <span
                    v-if="selectedStops && selectedStops != 'Any Stop'"
                    class="d-flex op-font"
                    style="font-size:14px;"
                  >
                    <span class="fw-500">Stops:</span>
                    <div class="ms-1">
                      <span>{{ selectedStops }}</span>
                      <span>,</span>
                    </div>
                    <span class="ms-1 fw-500">|</span>
                  </span>

                  <span
                    v-if="layDuration && Object.keys(layDuration).length > 0"
                    class="d-flex op-font"
                  >
                    <span class="fw-500" style="font-size:14px;">Layover:</span>
                    <div class="ms-1" style="font-size:14px;">
                      <span
                        >{{
                          layDuration.min == 12
                            ? `${layDuration.min}+`
                            : `${layDuration.min}-${layDuration.max}`
                        }}
                        hrs</span
                      >
                      <!-- <span>,</span> -->
                    </div>
                    <span class="ms-1 fw-500" style="font-size:14px;">|</span>
                  </span>

                  <span v-if="AvoidCountry.length > 0" class="d-flex op-font" style="font-size:14px;">
                    <span class="fw-500">Avoidcountry:</span>
                    <div
                      v-for="(data, index) of AvoidCountry"
                      :key="index"
                      class="ms-1"
                    >
                      <span>{{ data }}</span>
                      <span v-if="index !== AvoidCountry.length - 1">,</span>
                    </div>
                    <span class="ms-1 fw-500">|</span>
                  </span>

                  <span
                    v-if="includedAirports.length > 0"
                    class="d-flex op-font"
                    style="font-size:14px;"
                  >
                    <span class="fw-500">INCL AIRPORTS:</span>
                    <div
                      v-for="(data, index) of includedAirports"
                      :key="index"
                      class="ms-1"
                    >
                      <span>{{ data }}</span>
                      <span v-if="index !== includedAirports.length - 1"
                        >,</span
                      >
                    </div>
                    <span class="ms-1 fw-500">|</span>
                  </span>

                  <span
                    v-if="excludedAirports.length > 0"
                    class="d-flex op-font"
                    style="font-size:14px;"
                    ><span class="fw-500">EXCL AIRPORTS:</span>
                    <div
                      v-for="(data, index) of excludedAirports"
                      :key="index"
                      class="ms-1"
                    >
                      <span>{{ data }}</span>
                      <span v-if="index !== excludedAirports.length - 1"
                        >,</span
                      >
                    </div>
                    <span class="ms-1 fw-500">|</span>
                  </span>

                  <span v-if="selectedDays" class="d-flex op-font" style="font-size:14px;">
                    <span class="fw-500">AlternateDays:</span>
                    <div class="ms-1">
                      <span>{{ selectedDays }}</span>
                    </div>
                    <span class="ms-1 fw-500">|</span>
                  </span>

                  <span
                    v-if="selectedFareTypes.length > 0"
                    class="d-flex op-font"
                    style="font-size:14px;"
                  >
                    <span class="fw-500">FareType:</span>
                    <div
                      v-for="(data, index) of selectedFareTypes"
                      :key="index"
                      class="ms-1"
                    >
                      <span>{{ data }}</span>
                      <span v-if="index !== selectedFareTypes.length - 1"
                        >,</span
                      >
                    </div>
                  </span>

                  <span
                    v-if="selectedPenalties.length > 0"
                    class="d-flex op-font"
                    style="font-size:14px;"
                  >
                    <span class="fw-500">| Penalties:</span>
                    <div
                      v-for="(data, index) of selectedPenalties"
                      :key="index"
                      class="ms-1"
                    >
                      <span>{{ data }}</span>
                      <span v-if="index !== selectedPenalties.length - 1"
                        >,</span
                      >
                    </div>
                  </span>

                  <span v-if="filterIcon()">
                    <v-icon
                      class="ms-2"
                      @click="clearadOption()"
                      size="17px"
                      color="red"
                      style="cursor: pointer"
                    >
                      mdi-close-circle
                    </v-icon>
                  </span>
                </div>
                <div></div>
              </div>

              <div
                class="col-md-3 d-flex align-items-center justify-content-end custom-font ms-auto"
              >
                <span
                  class="not-collapsed collapsed f-size-13"
                  data-bs-toggle="collapse"
                  href="#collapse-Example"
                  aria-expanded="false"
                  aria-controls="collapse-Example"
                  style="
                    padding-right: 5px;
                    cursor: pointer;
                    letter-spacing: 1px;
                  "
                  @click="toggleIcon"
                >
                  <span style="color: navy; text-decoration: underline; font-size:14px"
                    >Advanced options</span
                  >
                </span>

                <v-icon
                  size="17"
                  class="not-collapsed collapsed me-3"
                  data-bs-toggle="collapse"
                  href="#collapse-Example"
                  aria-expanded="false"
                  aria-controls="collapse-Example"
                  v-model="isAdvanceOpt"
                  style="color: navy; cursor: pointer; overflow-anchor: none"
                >
                  {{
                    isAdvanceOpt
                      ? "mdi-chevron-up-box-outline"
                      : "mdi-chevron-down-box-outline"
                  }}</v-icon
                >
              </div>
            </div>

            <div
              class="p-1 collapse border-1 border-top"
              :class="{ show: isAdvanceOpt }"
              id="collapse-Example"
            >
              <div class="row gx-2 ps-2 dropdownSection">
                <div class="col-lg-12 col-12 px-0">
                  <div
                    class="text-center mt-2 gx-3 justify-content-start d-flex gap-3 flex-wrap"
                  >
                    <div>
                      <div class="dropdown">
                        <button
                          class="btn btn-primary dropdown-toggle btn-text"
                          :class="
                            isDropdownActive('airlines')
                              ? 'activeBtn'
                              : 'advanceBtn'
                          "
                          type="button"
                          id="dropdownMenuButtonAirlines"
                          data-toggle="dropdown"
                          data-bs-auto-close="false"
                          @click="toggleDropdown('airlines')"
                          :aria-expanded="isDropdownActive('airlines')"
                        >
                          Airlines
                        </button>

                        <div
                          class="dropdown-menu p-3"
                          :class="{ show: isDropdownActive('airlines') }"
                        >
                          <div class="form-check form-check-inline ps-0">
                            <div class="d-flex align-center">
                              <input
                                type="radio"
                                v-model="airex"
                                :value="true"
                                name="fav_language"
                              />
                              <label class="ms-1" for="includeOptionAirlines"
                                >Include</label
                              >
                            </div>
                          </div>
                          <div class="form-check form-check-inline">
                            <div class="d-flex align-center">
                              <input
                                type="radio"
                                v-model="airex"
                                :value="false"
                                name="fav_language"
                              />
                              <label class="ms-1" for="excludeOptionAirlines"
                                >Exclude</label
                              >
                            </div>
                          </div>
                          <input
                            v-if="airex"
                            type="text"
                            @input="handleAirportInput($event, 1)"
                            placeholder="Airline code/Name"
                            class="form-control mt-2"
                            v-model="airlineIncludeExclude"
                          />

                          <input
                            v-if="!airex"
                            type="text"
                            @input="handleAirportInput($event, 2)"
                            placeholder="Airline code/Name"
                            class="form-control mt-2"
                            v-model="airlineIncludeExclude1"
                          />

                          <div
                            v-if="airlineval"
                            style="font-size: 13px; color: red"
                          >
                            please enter the Airlines
                          </div>

                          <div class="d-flex justify-end">
                            <button
                              class="btn btn-primary mt-3 w-100 donebtn"
                              @click="addAirport1()"
                            >
                              Done
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div class="dropdown">
                        <button
                          class="btn btn-primary btn-text dropdown-toggle"
                          :class="
                            isDropdownActive('stops')
                              ? 'activeBtn'
                              : 'advanceBtn'
                          "
                          type="button"
                          id="dropdownMenuButton2"
                          data-bs-toggle="dropdown"
                          @click="toggleDropdown('stops')"
                          :aria-expanded="isDropdownActive('stops')"
                          data-bs-auto-close="false"
                        >
                          Stops
                        </button>
                        <ul
                          class="dropdown-menu p-3"
                          :class="{ show: isDropdownActive('stops') }"
                          aria-labelledby="dropdownMenuButton2"
                        >
                          <li class="form-check ps-0">
                            <!-- <input
                              class="form-check-input"
                              type="checkbox"
                              @change="handleCheck('Any Stop')"
                              :checked="selectedStops === 'Any Stop'"
                            /> -->
                            <v-icon
                              color="primary"
                              size="23"
                              :disabled="!selectedStops"
                              :class="{ 'disabled-icon': selectedStops }"
                              >mdi-check
                            </v-icon>
                            <label
                              class="form-check-label"
                              :class="{ 'disabled-label': selectedStops }"
                            >
                              Any Stop
                            </label>
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkboxstop1"
                              value="0"
                              @change="handleCheck('0')"
                              :checked="selectedStops === '0'"
                            />
                            <label class="form-check-label" for="checkboxstop1"
                              >Non-Stop</label
                            >
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkboxstop2"
                              value="1"
                              @change="handleCheck('1')"
                              :checked="selectedStops === '1'"
                            />
                            <label class="form-check-label" for="checkboxstop2"
                              >upto 1 Stop</label
                            >
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkboxstop3"
                              value="2"
                              @change="handleCheck('2')"
                              :checked="selectedStops === '2'"
                            />
                            <label class="form-check-label" for="checkboxstop3"
                              >upto 2 Stops</label
                            >
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkboxstop4"
                              value="3"
                              @change="handleCheck('3')"
                              :checked="selectedStops === '3'"
                            />
                            <label class="form-check-label" for="checkboxstop4"
                              >upto 3 Stops</label
                            >
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkboxstop5"
                              value="4"
                              @change="handleCheck('4')"
                              :checked="selectedStops === '4'"
                            />
                            <label class="form-check-label" for="checkboxstop5"
                              >4+ Stops</label
                            >
                          </li>
                          <li class="mt-2">
                            <div class="d-flex justify-end">
                              <a
                                class="btn btn-primary w-100 donebtn"
                                @click="toggleDropdown('airlinesooo')"
                                >Done</a
                              >
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div>
                      <div class="dropdown">
                        <button
                          class="btn btn-primary btn-text dropdown-toggle"
                          :class="
                            isDropdownActive('Layover')
                              ? 'activeBtn'
                              : 'advanceBtn'
                          "
                          type="button"
                          id="dropdownMenuButton2"
                          data-bs-toggle="dropdown"
                          @click="toggleDropdown('Layover')"
                          :aria-expanded="isDropdownActive('Layover')"
                          data-bs-auto-close="false"
                        >
                          Layover Duration
                        </button>
                        <ul
                          class="dropdown-menu p-3"
                          :class="{ show: isDropdownActive('Layover') }"
                          aria-labelledby="dropdownMenuButton2"
                        >
                          <li class="form-check ps-0">
                            <v-icon
                              color="primary"
                              size="23"
                              :disabled="!layDuration"
                              :class="{ 'disabled-icon': layDuration }"
                              >mdi-check
                            </v-icon>
                            <label
                              class="form-check-label"
                              :class="{ 'disabled-label': layDuration }"
                            >
                              No Preference
                            </label>
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkbox1"
                              :value="{ min: 1, max: 3 }"
                              @change="handleLayDuration({ min: 1, max: 3 })"
                              :checked="
                                layDuration &&
                                layDuration.min === 1 &&
                                layDuration.max === 3
                              "
                            />

                            <label class="form-check-label" for="checkbox1">
                              1-3 hrs
                            </label>
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkbox2"
                              :value="{ min: 3, max: 6 }"
                              @change="handleLayDuration({ min: 3, max: 6 })"
                              :checked="
                                layDuration &&
                                layDuration.min === 3 &&
                                layDuration.max === 6
                              "
                            />

                            <label class="form-check-label" for="checkbox2">
                              3-6 hrs
                            </label>
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkbox3"
                              :value="{ min: 6, max: 12 }"
                              @change="handleLayDuration({ min: 6, max: 12 })"
                              :checked="
                                layDuration &&
                                layDuration.min === 6 &&
                                layDuration.max === 12
                              "
                            />
                            <label class="form-check-label" for="checkbox3">
                              6-12 hrs
                            </label>
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkbox4"
                              :value="{ min: 12, max: 24 }"
                              @change="handleLayDuration({ min: 12, max: 24 })"
                              :checked="
                                layDuration &&
                                layDuration.min === 12 &&
                                layDuration.max === 24
                              "
                            />
                            <label class="form-check-label" for="checkbox4">
                              12+ hrs
                            </label>
                          </li>

                          <li class="mt-2">
                            <div class="d-flex justify-end">
                              <a
                                class="btn btn-primary w-100 donebtn"
                                @click="
                                  submitLayover,
                                    toggleDropdown('airlinesooo'),
                                    console.log(layDuration, 'pppp')
                                "
                                >Done</a
                              >
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div>
                      <div class="dropdown">
                        <button
                          class="btn btn-primary btn-text dropdown-toggle"
                          :class="
                            isDropdownActive('Via-Airport')
                              ? 'activeBtn'
                              : 'advanceBtn'
                          "
                          type="button"
                          id="dropdownMenuButtonAirports"
                          data-bs-toggle="dropdown"
                          @click="toggleDropdown('Via-Airport')"
                          :aria-expanded="isDropdownActive('Via-Airport')"
                          data-bs-auto-close="false"
                        >
                          Via-Airport
                        </button>
                        <div
                          class="dropdown-menu p-3"
                          :class="{ show: isDropdownActive('Via-Airport') }"
                        >
                          <div class="form-check form-check-inline ps-0">
                            <div class="d-flex align-center">
                              <input
                                type="radio"
                                v-model="includeExclude"
                                value="include"
                                id="includeOptionAirports"
                              />
                              <label class="ms-1" for="includeOptionAirports"
                                >Include</label
                              >
                            </div>
                          </div>
                          <div class="form-check form-check-inline">
                            <div class="d-flex align-center">
                              <input
                                type="radio"
                                v-model="includeExclude"
                                value="exclude"
                                id="excludeOptionAirports"
                              />
                              <label class="ms-1" for="excludeOptionAirports"
                                >Exclude</label
                              >
                            </div>
                          </div>
                          <input
                            v-if="includeExclude === 'include'"
                            type="text"
                            v-model="formattedAirportInput"
                            @input="updateAirportInput($event, 'include')"
                            placeholder="Airport code/Name"
                            class="form-control mt-2"
                          />

                          <input
                            v-if="includeExclude === 'exclude'"
                            type="text"
                            v-model="formattedAirportInput1"
                            @input="updateAirportInput($event, 'exclude')"
                            placeholder="Airport code/Name"
                            class="form-control mt-2"
                          />

                          <div
                            v-if="airlineval1"
                            style="font-size: 13px; color: red"
                          >
                            please enter the Airport
                          </div>

                          <div class="d-flex justify-end">
                            <button
                              class="btn btn-primary mt-3 w-100 donebtn"
                              @click="addAirport()"
                            >
                              Done
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div class="dropdown">
                        <button
                          class="btn btn-primary btn-text dropdown-toggle"
                          :class="
                            isDropdownActive('Avoid Country')
                              ? 'activeBtn'
                              : 'advanceBtn'
                          "
                          type="button"
                          id="dropdownMenuButton4"
                          data-bs-toggle="dropdown"
                          @click="toggleDropdown('Avoid Country')"
                          :aria-expanded="isDropdownActive('Avoid Country')"
                          data-bs-auto-close="false"
                        >
                          Avoid Country
                        </button>
                        <ul
                          class="dropdown-menu p-3"
                          :class="{ show: isDropdownActive('Avoid Country') }"
                          aria-labelledby="dropdownMenuButton6"
                        >
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="avoid-us"
                              value="US"
                              v-model="AvoidCountry"
                            />

                            <label class="form-check-label" for="avoid-us">US</label>
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="avoid-uk"
                              value="UK"
                              v-model="AvoidCountry"
                            />
                            <label class="form-check-label" for="avoid-uk">
                              UK
                            </label>
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="avoid-ca"
                              value="CA"
                              v-model="AvoidCountry"
                            />
                            <label class="form-check-label" for="avoid-ca">
                              CA
                            </label>
                          </li>
                          <li class="mt-2">
                            <div class="d-flex justify-end">
                              <a
                                class="btn btn-primary w-100 donebtn"
                                @click="
                                  handleSubmit, toggleDropdown('Avoid Country')
                                "
                                >Done</a
                              >
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {{console.log(isMulticity,'multicity')}}
                    <div v-if="!isMulticity">
                      <div class="dropdown">
                        <button
                          class="btn btn-primary btn-text dropdown-toggle"
                          :class="
                            isDropdownActive('Alternate')
                              ? 'activeBtn'
                              : 'advanceBtn'
                          "
                          type="button"
                          id="dropdownMenuButton5"
                          data-bs-toggle="dropdown"
                          @click="toggleDropdown('Alternate')"
                          :aria-expanded="isDropdownActive('Alternate')"
                          data-bs-auto-close="false"
                        >
                          Alternate Days
                        </button>
                        <ul
                          class="dropdown-menu p-3"
                          :class="{ show: isDropdownActive('Alternate') }"
                          aria-labelledby="dropdownMenuButton5"
                          style="cursor: pointer"
                        >
                          <li
                            v-for="(day, index) in days"
                            :key="index"
                            class="mt-2 p-1"
                            :style="{
                              border: '1px solid grey',
                              backgroundColor: day.valdata ? 'gold' : 'white',
                            }"
                          >
                            <div
                              @click="selectDays(day, index)"
                              class="d-flex justify-space-between"
                            >
                              <div>
                                {{ day.label }}
                              </div>
                              <div style="display: flex; align-items: center">
                                <v-icon size="16" color="grey"
                                  >mdi-close</v-icon
                                >
                              </div>
                            </div>
                          </li>
                          <li
                            class="mt-2"
                            @click="toggleDropdown('airlinesooo')"
                          >
                            <div class="d-flex justify-end">
                              <a class="btn btn-primary w-100 donebtn">Done</a>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div>
                      <div class="dropdown">
                        <button
                          class="btn btn-primary btn-text dropdown-toggle"
                          :class="
                            isDropdownActive('Fare Type')
                              ? 'activeBtn'
                              : 'advanceBtn'
                          "
                          type="button"
                          id="dropdownMenuButton6"
                          data-bs-toggle="dropdown"
                          @click="toggleDropdown('Fare Type')"
                          :aria-expanded="isDropdownActive('Fare Type')"
                          data-bs-auto-close="false"
                        >
                          Fare Type
                        </button>
                        <ul
                          class="dropdown-menu p-3"
                          :class="{ show: isDropdownActive('Fare Type') }"
                          aria-labelledby="dropdownMenuButton6"
                        >
                          <li class="form-check ps-0">
                            <!-- <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkbox11"
                              checked
                              :disabled="selectedFareTypes.length > 0"
                            /> -->
                            <v-icon
                              color="primary"
                              size="23"
                              :class="{
                                'disabled-icon': selectedFareTypes.length > 0,
                              }"
                              >mdi-check
                            </v-icon>
                            <label
                              class="form-check-label"
                              :class="{
                                'disabled-label': selectedFareTypes.length > 0,
                              }"
                            >
                              Any FareType
                            </label>
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkbox11"
                              value="PUB"
                              v-model="selectedFareTypes"
                            />
                            <label class="form-check-label" for="checkbox11"
                              >PUB</label
                            >
                          </li>
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkbox21"
                              value="NET"
                              v-model="selectedFareTypes"
                            />
                            <label class="form-check-label" for="checkbox21"
                              >NET</label
                            >
                          </li>
                          <li
                            class="mt-2"
                            @click="toggleDropdown('airlinesooo')"
                          >
                            <div class="d-flex justify-end">
                              <a class="btn btn-primary w-100 donebtn">Done</a>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div>
                      <div class="dropdown">
                        <button
                          class="btn btn-primary btn-text dropdown-toggle"
                          :class="
                            isDropdownActive('Penalties')
                              ? 'activeBtn'
                              : 'advanceBtn'
                          "
                          type="button"
                          id="dropdownMenuButton7"
                          data-bs-toggle="dropdown"
                          @click="toggleDropdown('Penalties')"
                          :aria-expanded="isDropdownActive('Penalties')"
                          data-bs-auto-close="false"
                        >
                          Penalties
                        </button>
                        <ul
                          class="dropdown-menu p-3"
                          :class="{ show: isDropdownActive('Penalties') }"
                          aria-labelledby="dropdownMenuButton7"
                        >
                          <!-- <li class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="checkbox1"
                                value="Zero Change fee"
                                v-model="selectedPenalties"
                              />
                              <label class="form-check-label" for="checkbox1"
                                >Zero Change fee</label
                              >
                            </li>
                            <li class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="checkbox2"
                                value="No Cancellation fees"
                                v-model="selectedPenalties"
                              />
                              <label class="form-check-label" for="checkbox2"
                                >No Cancellation fees</label
                              >
                            </li> -->
                          <li class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="checkbox39"
                              value="Refundable"
                              v-model="selectedPenalties"
                            />
                            <label class="form-check-label" for="checkbox39"
                              >Refundable</label
                            >
                          </li>

                          <li
                            class="mt-2"
                            @click="toggleDropdown('airlinesooo')"
                          >
                            <div class="d-flex justify-end">
                              <a class="btn btn-primary w-100 donebtn">Done</a>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div>
                    <div class="dropdown">
                      <button class="btn btn-primary btn-text dropdown-toggle"
                        :class=" isDropdownActive('ContentSource')
                         ? 'activeBtn' : 'advanceBtn'"
                        type="button"
                        id="dropdownMenuButton8"
                        data-bs-toggle="dropdown"
                        @click="toggleDropdown('ContentSource')"
                        :aria-expanded="isDropdownActive('ContentSource')"
                        data-bs-auto-close="false"
                      >
                        Content Source
                      </button>
                      <ul class="dropdown-menu p-3"
                        :class="{ show: isDropdownActive('ContentSource') }"
                      >
                      <li class="d-flex flex-row align-center">
                        <div class="form-check ps-0">
                          <input type="radio"
                            id="csDefault"
                            value="default"
                            v-model="contentSourceMode"
                          />
                          <label class="form-check-label" for="csDefault">
                             Default
                          </label>
                        </div>

                        <div class="form-check">
                          <input type="radio"
                            id="csFiltered"
                            value="filtered"
                            v-model="contentSourceMode"
                          />
                          <label class="form-check-label" for="csFiltered">
                            Filter
                          </label>
                        </div>
                      </li>

                      <hr />

                      <li class="form-check"
                        v-for="(item, index) in contentSourceList"
                        :key="index"
                      >
                      <input class="form-check-input"
                        type="checkbox" :id="'content_' + index"
                        :value="item.identifier"
                        v-model="selectedContentSource"
                        :disabled="contentSourceMode === 'default'"
                      />
                      <label class="form-check-label" :for="'content_' + index">
                        {{ item.name }}
                      </label>
                    </li>

                    <li class="mt-2" @click="toggleDropdown('airlinesooo')">
                      <div class="d-flex justify-end">
                        <a class="btn btn-primary w-100 donebtn">Done</a>
                      </div>
                    </li>
                  </ul>
                  </div>
                </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
</template>

<script>
import axios from 'axios'
import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";
export default {
    props:{
        advancedOptions:{
            type:Array
        },
        isMulticity:{
          type:Boolean
        }
    },
    data(){
        return{
            selectedFareTypes: [],
            selectedPenalties: [],
            includeExclude: "include",
            formattedAirportInput: "",
            formattedAirportInput1: "",
            includedAirports: [],
            excludedAirports: [],
            contentSourceList: [],
            selectedContentSource: [],
            contentSourceMode: 'default',
            airlineval: false,
            airlineval1: false,
            airlineIncludeExclude: "",
            airlineIncludeExclude1: "",
            airex: true,
            airlineInput: "",
            includedAirlines: [],
            excludedAirlines: [],
            activeDropdown: null,
            advaceData: {},
            selectedStops: "",
            layDuration: null,
            expandedGroupIndex:null,
            AvoidCountry: [],
            alterDays: [],
            selectedDays: "",
            advanceOptionvalue: "",
            isAdvanceOpt:false,
            days: [
                { label: "+/- 1 Days", value: "1", valdata: false },
                // { label: "+/- 2 Days", value: "2", valdata: false },
                { label: "+/- 3 Days", value: "3", valdata: false },
                //{ label: "+/- 7 Days", value: "7", valdata: false },
            ],
            getContentSrApi: "",
        }
    },
    created() {
      this.initializeConfig();
      this.getContentSource();
    },
    methods:{
      toggleIcon(){
        this.isAdvanceOpt = !this.isAdvanceOpt;
      },
        filterIcon() {
      let obj = {};

      obj.includedAirlines = this.includedAirlines;
      obj.excludedAirlines = this.excludedAirlines;
      obj.includedAirports = this.includedAirports;
      obj.excludedAirports = this.excludedAirports;
      obj.selectedDays = this.selectedDays;
      obj.selectedStops = this.selectedStops;
      obj.layDuration =
        this.layDuration && Object.keys(this.layDuration).length > 0;
      obj.AvoidCountry = this.AvoidCountry;
      obj.selectedPenalties = this.selectedPenalties;
      obj.selectedFareTypes = this.selectedFareTypes || this.fareType;

      return Object.values(obj).some((value) => {
        return Array.isArray(value) ? value.length > 0 : !!value;
      });
    },
     localDataValue() {
      let obj = {};

      obj.includedAirlines = this.includedAirlines;
      obj.excludedAirlines = this.excludedAirlines;
      obj.includedAirports = this.includedAirports;
      obj.excludedAirports = this.excludedAirports;
      obj.selectedDays = this.selectedDays;
      obj.selectedStops = this.selectedStops;
      obj.layDuration = this.layDuration;
      obj.AvoidCountry = this.AvoidCountry;
      obj.selectedPenalties = this.selectedPenalties;
      obj.selectedFareTypes = this.selectedFareTypes;
      obj.selectedContentSource = this.selectedContentSource;
      obj.contentSourceMode = this.contentSourceMode;

      this.advaceData = obj;
      this.$emit('advancedData',this.advaceData)

      // localStorage.setItem("advanceOption", JSON.stringify(obj));
    },
    clearadOption() {
      this.includedAirlines = [];
      this.excludedAirlines = [];
      this.selectedStops = "";
      this.AvoidCountry = [];
      this.includedAirports = [];
      this.excludedAirports = [];
      (this.selectedDays = ""), (this.selectedFareTypes = []);
      this.selectedPenalties = [];
      this.contentSourceMode = "default";
      this.selectedContentSource = this.contentSourceList.map(item => item.identifier);

      this.includeExclude = "include";
      this.airlineIncludeExclude = "";
      // this.selectedStops
      this.formattedAirportInput1 = "";
      // this.selectedStops
      this.layDuration = null;
      this.formattedAirportInput = "";
      this.AvoidCountry = [];
      this.localDataValue()
    },
    toggleDropdown(dropdownName) {
      if (this.activeDropdown === dropdownName) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = dropdownName;
        // this.isDropdownActive(false);
      }
    },
    isDropdownActive(dropdownName) {
      return this.activeDropdown === dropdownName;
    },
    addAirline() {
      console.log(this.airlineInput, "this.airlineInput");

      if (this.airlineInput.trim()) {
        const airlinePairs = this.airlineInput
          .toUpperCase()
          .match(/.{1,2}/g)
          .join(",");

        console.log(airlinePairs, "airlines formatted");

        if (this.airlineIncludeExclude === "include") {
          this.includedAirlines = [];
          this.includedAirlines.push(airlinePairs);
        } else if (this.airlineIncludeExclude === "exclude") {
          this.excludedAirlines = []; // Clear the array before adding new airlines
          this.excludedAirlines.push(airlinePairs);
        }

        console.log(
          this.includedAirlines,
          this.excludedAirlines,
          "formatted airlines"
        );

        // Clear the input field after submission
        // this.airlineInput = "";
      }
    },
    initializeConfig() {
      const config = getConfigDataFromLocalStorage();
      if (config && config.payload && config.payload.portal_configuration) {
        const endpoints = config.payload.portal_configuration.API_endpoints;
        this.getContentSrApi = endpoints.contentsource || endpoints.content_source || "";
      }
    },
    getContentSource(){
      const config = getConfigDataFromLocalStorage();
      let domainName = ""
      if (config && config.payload && config.payload.portal_configuration) {
        domainName = config.payload.portal_configuration.portal_url.replace("https://", "").split('/')[0];
      } else if (window.location.hostname !== "localhost") {
        domainName = window.location.hostname;
      }
      let req = {
        "service_type": "GetPortalConfigRQ",
        "api_ver": "1",
        "payload": {
          "domain_name": domainName,
          "env": "CERT",
          "language": "EN",
          "token": "jsdjOJDKJ7675",
          "platform_source": "b2b"
        }
      };

      const fallbackList = [];
      if(this.getContentSourceApi === "") {
        console.log("Content source API endpoint is not defined.");
        this.contentSourceList = fallbackList;
        return;
      }

      axios.post(this.getContentSrApi, req, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res, 'getContentSource');
        let rawData = [];
        if (res.data) {
          if (Array.isArray(res.data)) {
            rawData = res.data;
          } else if (res.data.payload && res.data.payload.portal_configuration && Array.isArray(res.data.payload.portal_configuration.content_sources)) {
            rawData = res.data.payload.portal_configuration.content_sources;
          } else if (res.data.payload && Array.isArray(res.data.payload.content_sources)) {
            rawData = res.data.payload.content_sources;
          }
        }
        
        const filteredList = rawData.filter(
          (item) => item && typeof item === 'object' && !Array.isArray(item) && item.identifier && item.name
        );

        this.contentSourceList = filteredList.length > 0 ? filteredList : fallbackList;

        if (this.contentSourceMode === 'default') {
          this.selectedContentSource = this.contentSourceList.map(item => item.identifier);
        } else if (this.contentSourceMode === 'filtered') {
          if (!this.selectedContentSource || this.selectedContentSource.length === 0) {
            this.selectedContentSource = this.contentSourceList.map(i => i.identifier);
          }
        }
      })
      .catch((err) => {
        console.log("API failed to get content sources, using fallback", err);
        this.contentSourceList = fallbackList;
        if (this.contentSourceMode === 'default') {
          this.selectedContentSource = this.contentSourceList.map(item => item.identifier);
        } else if (this.contentSourceMode === 'filtered') {
          if (!this.selectedContentSource || this.selectedContentSource.length === 0) {
            this.selectedContentSource = this.contentSourceList.map(i => i.identifier);
          }
        }
      });
    },
    updateAirportInput(event, mode) {
      const rawInput = event.target.value.toUpperCase();
      const sanitizedInput = rawInput.replace(/[^A-Z]/g, "");
      const airportCodes = sanitizedInput.match(/.{1,3}/g) || [];
      const uniqueCodes = [...new Set(airportCodes)];
      const formatted = uniqueCodes.join(", ");

      if (mode === "include") {
        this.formattedAirportInput = formatted;
      } else {
        this.formattedAirportInput1 = formatted;
      }

      this.airlineval1 = false;
    },
    handleAirportInput(event, num) {
      const inputElement = event.target;
      let cursorPosition = inputElement.selectionStart;

      let rawInput = inputElement.value.toUpperCase();

      let sanitizedInput = rawInput.replace(/[^A-Z]/g, "");

      let codes = sanitizedInput.match(/.{1,2}/g) || [];

      let uniqueCodes = [...new Set(codes)];

      let formatted = uniqueCodes.join(", ");

      let charsAdded = formatted.length - rawInput.length;

      if (num === 1) {
        this.airlineIncludeExclude = formatted;
      } else {
        this.airlineIncludeExclude1 = formatted;
      }

      this.$nextTick(() => {
        const newCursorPosition = cursorPosition + charsAdded;
        inputElement.setSelectionRange(newCursorPosition, newCursorPosition);
      });
    },

    addAirport() {
      const airportValue =
        this.includeExclude === "include"
          ? this.formattedAirportInput
          : this.formattedAirportInput1;

      const airportCodes = airportValue
        .toUpperCase()
        .split(",")
        .map((code) => code.trim())
        .filter((code) => code.length > 0);

      const hasInvalidCode = airportCodes.some((code) => code.length !== 3);

      if (!airportCodes.length || hasInvalidCode) {
        this.airlineval1 = true;
        return;
      }

      this.airlineval1 = false;

      if (this.includeExclude === "include") {
        this.excludedAirports = [];
        this.includedAirports = [...new Set(airportCodes)];
        this.formattedAirportInput1 = "";
      } else {
        this.includedAirports = [];
        this.excludedAirports = [...new Set(airportCodes)];
        this.formattedAirportInput = "";
      }

      this.toggleDropdown("Via-Airport");

      console.log("Included Airports:", this.includedAirports);
      console.log("Excluded Airports:", this.excludedAirports);
    },
    addAirport1() {
      let airlineCodes = (
        this.airex ? this.airlineIncludeExclude : this.airlineIncludeExclude1
      )
        .toUpperCase()
        .split(",")
        .map((code) => code.trim())
        .filter((code) => code.length === 2);

      if (this.airex) {
        this.excludedAirlines = [];
        this.includedAirlines = this.includedAirlines.filter((code) =>
          airlineCodes.includes(code)
        );
        airlineCodes.forEach((code) => {
          if (!this.includedAirlines.includes(code)) {
            this.includedAirlines.push(code);
          }
        });
        this.airlineIncludeExclude1 = "";
      } else {
        this.includedAirlines = [];
        this.excludedAirlines = this.excludedAirlines.filter((code) =>
          airlineCodes.includes(code)
        );
        airlineCodes.forEach((code) => {
          if (!this.excludedAirlines.includes(code)) {
            this.excludedAirlines.push(code);
          }
        });
        this.airlineIncludeExclude = "";
      }

      this.toggleDropdown("airlines");

      console.log("Included Airlines:", this.includedAirlines);
      console.log("Excluded Airlines:", this.excludedAirlines);
      // if (this.airex) {
      //   this.ailineSetUp(this.airlineIncludeExclude);
      // } else {
      //   this.ailineSetUp(this.airlineIncludeExclude1);
      // }
    },

    ailineSetUp(event) {
      let $event = event.split(" ").join("");
      console.log($event, this.airex, "$event");

      if ($event) {
        let $data = [];
        $data = $event.split(",");
        let uniqueData = [...new Set($data)];
        let count = uniqueData[uniqueData.length - 1].length;
        console.log(count, $data, $data[$data.length - 1].length, "000");
        if (this.airex && count == 2) {
          this.includedAirlines = [];
          uniqueData.forEach((airline) => {
            if (!this.includedAirlines.includes(airline)) {
              this.includedAirlines.push(airline);
            }
          });
          this.toggleDropdown("airlines");
          // console.log($event, this.airex, "$event11");
        } else if (!this.airex && count == 2) {
          this.excludedAirlines = [];
          uniqueData.forEach((airline) => {
            if (!this.excludedAirlines.includes(airline)) {
              this.excludedAirlines.push(airline);
            }
          });
          this.toggleDropdown("airlines");
          // console.log($event, this.airex, "$event22");
        } else {
          this.airlineval = true;
          // console.log($event, this.airex, "$event33");
        }
      } else {
        this.toggleDropdown("airlines");
      }
    },

    selectDays(day, index) {
      console.log(day, "days");
      this.days.forEach((c, i) => {
        if (i == index) {
          c.valdata = !c.valdata;
          this.selectedDays = c.valdata ? c.value : "";
        } else {
          c.valdata = false;
        }
      });
      // this.days[index].valdata = !this.days[index].valdata
    },
    minDate() {
      const today = new Date();
      // Setting time to 00:00:00 to avoid timezone issues
      return new Date(
        Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())
      )
        .toISOString()
        .split("T")[0];
    },
    maxDate() {
      const today = new Date();
      return new Date(
        Date.UTC(today.getFullYear() + 1, today.getMonth(), today.getDate())
      )
        .toISOString()
        .split("T")[0];
    },
    handleCheck(value) {
      // this.selectedStops = value;
      if (this.selectedStops === value) {
        this.selectedStops = "";
      } else {
        this.selectedStops = value;
      }

      // console.log('Selected Stops:', this.selectedStops);
    },
    handleLayDuration(value) {
      if (
        this.layDuration &&
        this.layDuration.min === value.min &&
        this.layDuration.max === value.max
      ) {
        this.layDuration = null;
      } else {
        this.layDuration = { min: value.min, max: value.max };
      }

      // console.log('layDuration', this.layDuration);
    },
    },
    computed:{
        clearallFilter() {
            if (
                this.includedAirlines?.length > 0 ||
                this.excludedAirlines?.length > 0 ||
                this.selectedStops >= 0 ||
                this.AvoidCountry?.length > 0 ||
                this.includedAirports?.length > 0 ||
                this.excludedAirports?.length > 0 ||
                this.selectedDays?.length > 0 ||
                this.selectedFareTypes?.length > 0 ||
                this.selectedPenalties?.length > 0
            ) {
                return true;
            } else {
                return false;
            }
        }
    },
    watch:{
        includedAirlines: "localDataValue",
        excludedAirlines: "localDataValue",
        includedAirports: "localDataValue",
        excludedAirports: "localDataValue",
        selectedDays: "localDataValue",
        selectedStops: "localDataValue",
        layDuration: "localDataValue",
        AvoidCountry: "localDataValue",
        selectedPenalties: "localDataValue",
        selectedFareTypes: "localDataValue",

        advancedOptions: {
            handler(newVal) {
            console.log(newVal, 'advancedData')
            if(newVal){
                this.selectedFareTypes = newVal?.selectedFareTypes ?? this.fareType;
                this.includedAirlines = newVal?.includedAirlines ?? [];
                this.excludedAirlines = newVal?.excludedAirlines ?? [];
                this.airlineIncludeExclude = this.includedAirlines.join();
    
                this.includedAirports = newVal?.includedAirports ?? [];
                this.airlineIncludeExclude1 = this.excludedAirlines.join();
    
                this.excludedAirports = newVal?.excludedAirports ?? [];
                this.formattedAirportInput = this.includedAirports.join(", ");
                this.formattedAirportInput1 = this.excludedAirports.join(", ");

                if (this.excludedAirports.length > 0) {
                    this.includeExclude = "exclude";
                } else {
                    this.includeExclude = "include";
                }
                this.layDuration = newVal?.layDuration ?? null;
                this.selectedStops = newVal?.selectedStops ?? "";
                this.selectedDays = newVal?.selectedDays ?? "";
                this.AvoidCountry = newVal?.AvoidCountry ?? [];
                this.selectedPenalties = newVal?.selectedPenalties ?? [];
                this.selectedContentSource = newVal?.selectedContentSource ?? [];
                this.contentSourceMode = newVal?.contentSourceMode ?? 'default';
    
                if (this.excludedAirlines?.length > 0) {
                    this.airex = false;
                } else if (this.includedAirlines?.length > 0) {
                    this.airex = true;
                } else {
                    this.airex = true;
                }
            }
            else{
              console.log(newVal,'elseAdvanceOptions')
            }
            },
            deep: true,
            immediate: true
        },
        contentSourceMode(newVal) {
          if (newVal === 'default') {
            this.selectedContentSource = this.contentSourceList.map(
              item => item.identifier
            );
          } else if (this.contentSourceMode === 'filtered') {
            this.selectedContentSource = this.contentSourceList.map(i => i.identifier)
          }
          this.localDataValue();
        },
        selectedContentSource: {
          handler() {
            this.localDataValue();
          },
          deep: true
        },
        
    },
}
</script>

<style scoped>
.advanceOpt
  .dropdownSection
  .dropdown
  :is(.advanceBtn:hover, .activeBtn:hover) {
  background: lightgray !important;
  color: black;
}

.advanceOpt .dropdownSection .dropdown .advanceBtn {
  background: none;
  color: black;
  border: none;
  border-bottom: 1px solid darkgray;
  border-radius: 0;
  padding-bottom: 4px !important;
  font-size:14px;
  padding-top:5px;
  padding-left:6px;
  padding-right:6px;
}

.activeBtn {
  border-bottom: 2px solid #000000 !important;
  background: lightgray;
  border: none;
  border-radius: 0;
  color: black;
  padding-bottom: 4px !important;
  padding-top:5px !important;
  padding-left:6px;
  padding-right:6px;
}

.advanceOpt .dropdownSection .dropdown .donebtn {
  width: 75px !important;
  padding: 0 !important;
  background: #f07626 !important;
  border-color: #f07626 !important;
  height:23px;
  display:flex;
  justify-content:center;
  align-items: center;
}
.border-top{
    border-top:1px solid #f07626 !important;
}
.disabled-icon {
  opacity: 0.5;
  pointer-events: none;
}

.disabled-label {
  color: #b1b1b1;
  pointer-events: none;
}
.flight-table {
  display: flex;
  justify-content: center;
}

.calenderSection table {
  width: 100%;
  table-layout: fixed;
}

.calenderSection .cal-se1 .priceFont {
  font-size: 10px !important;
  font-weight: 500 !important;
}
.calenderSection .cal-se1 .airIconimg {
  width: 10px !important;
}
.form-check-label{
    line-height:1.3;
}
.btn-primary:hover, .btn-primary:active, .btn-primary:focus{
    background-color:lightgray !important;
    color:black;
    font-size:14px;
}
th,
td {
  padding: 10px 4px;
  text-align: center;
  border: 1px solid lightblue;
}
.calenter-head {
  color: #551a8b;
  text-decoration: underline;
  text-decoration-color: #551a8b;
  font-size: 14px;
  font-weight: 500;
}
.disabled-cal {
  pointer-events: none;
  opacity: 0.6;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
}
.cal-se1 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  cursor: pointer;
}
.cal-se2 {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.cal-h3 {
  display: flex;
  justify-content: center;
}
.calSelect1 {
  box-shadow: none;
  border: 1px solid lightblue !important;
  text-align: center;
  width: 150px;
  font-size: 14px;
}
.calSelect {
  box-shadow: none;
  border: 4px solid gold !important;
  background: #dae7f7;
  text-align: center;
  width: 150px;
  font-size: 14px;
}
.dropdown-menu{
    width:260px;
}
.form-check-input[type=checkbox]{
    border:1px solid gray;
}
.btn{
  font-size:14px;
}
.donebtn:hover{
  color:white;
}
</style>
